import { kaspreadsheetUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      <div className="lg:w-1/2 relative overflow-hidden min-h-[400px] lg:min-h-[500px]">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flatlay%20product%20photography%20of%20stylish%20contemporary%20fashion%20items%20including%20sneakers%2C%20a%20watch%2C%20sunglasses%20and%20a%20crossbody%20bag%20arranged%20on%20a%20warm%20cream%20muslin%20fabric%20surface%20with%20soft%20natural%20window%20light%2C%20editorial%20flatlay%20composition%2C%20neutral%20beige%20and%20warm%20cream%20tones%2C%20Scandinavian%20minimalist%20lifestyle%20aesthetic%2C%20clean%20organic%20arrangement%2C%20soft%20shadows&width=1000&height=700&seq=cta-v2-left-u5m2&orientation=landscape"
          alt="Hoobuy Sheet produtos moda streetwear"
          title="Hoobuy Sheet - Produtos Virais"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
        <div className="absolute top-6 left-6">
          <span className="text-white/70 text-xs font-medium tracking-widest uppercase">
            hoobuy.biz 2026
          </span>
        </div>
        <div className="absolute bottom-8 left-6">
          <h2 className="text-white text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.1] font-heading">
            Hoobuy
            <br />
            Sheet
            <br />
            Atualizado
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-white flex items-center justify-center px-6 py-16 lg:py-0">
        <div className="max-w-md text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-950 font-heading leading-[1.15] mb-6">
            Acesse Agora
            <br />
            O Melhor Preço
          </h2>
          <p className="text-foreground-500 text-base leading-relaxed mb-8 max-w-md mx-auto">
            O <strong className="text-foreground-800">hoobuyspreadsheet</strong>{" "}
            reúne os produtos mais virais do momento com os melhores preços do
            mercado. Lista organizada, atualizada e verificada pela comunidade.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3 mb-8 text-sm text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-fill text-accent-500 text-base"></i>
              Produtos virais
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-fill text-accent-500 text-base"></i>
              Preços baixos
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-fill text-accent-500 text-base"></i>
              Atualização semanal
            </span>
          </div>
          <a
            href={kaspreadsheetUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2.5 px-8 py-4 bg-primary-500 text-background-50 text-base font-semibold rounded-full hover:bg-primary-600 transition-all hover:scale-[1.02] whitespace-nowrap cursor-pointer"
          >
            buy it now
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}